import { HTMLAttributes, MouseEvent, useState } from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Grid } from '@mui/material';
import styled from '@emotion/styled';
import type { OptionDraggableData, OptionItem } from '@/redux/slices/packagingSlice.types';
import EditorOption from '@/components/Packaging/common/EditorOption';

type DraggableCutTypesProps = HTMLAttributes<HTMLDivElement> & {
  option: OptionItem;
};

const DraggableEditorOption = ({ option, ...props }: DraggableCutTypesProps) => {
  const { draggableId, type, kind, label, segmentType } = option;
  const [cursorXPosition, setCursorXPosition] = useState(0);
  const data: OptionDraggableData = { type, segmentType, kind, cursorXPosition };
  const { isDragging, attributes, listeners, setNodeRef } = useDraggable({
    id: draggableId,
    data
  });

  const style = {
    cursor: isDragging ? 'grabbing' : 'grab',
    opacity: isDragging ? 0.3 : 1
  };

  const handleMouseMove = (event: MouseEvent<HTMLDivElement>) => {
    const { clientX, currentTarget } = event;
    const position = clientX - currentTarget.getBoundingClientRect().left;
    setCursorXPosition(position);
  };

  return (
    <Wrapper item ref={setNodeRef} xs={6} md={4} xl={3} onMouseMove={handleMouseMove} style={style} {...listeners} {...attributes} {...props}>
      <EditorOption kind={kind} label={label} draggable />
    </Wrapper>
  );
};

export default DraggableEditorOption;

const Wrapper = styled(Grid)`
  position: relative;
`;
